import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { logger } from "#app/monitoring/Logger";

export type QuoteRequestDto = ClientInferResponseBody<typeof contract.quoteRequests.findOne>;

const schema = contract.quoteRequests.findOne.responses[200];

export const fetchQuoteRequest = async (
  quoteRequestId: string | undefined,
): Promise<QuoteRequestDto> => {
  if (!quoteRequestId) {
    throw new Response(null, { status: 404, statusText: "Not Found" });
  }

  const response = await api.quoteRequests.findOne.query({
    params: {
      id: quoteRequestId,
    },
  });

  if (response.status === 200) {
    const parsedResponse = schema.safeParse(response.body);
    if (!parsedResponse.success) {
      logger.error("Failed to parse quote request");

      return response.body;
    }

    return parsedResponse.data;
  }

  throw new Response(null, {
    status: response.status,
    statusText: response.status === 404 ? "Not Found" : "Error",
  });
};
